import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { adminInstance } from '../services/axiosInstance'; // '../axiosInstance';
import { Form, Button, Table, InputGroup, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ExpenseReportPage() {
    const hierarchy = sessionStorage.getItem('role');
    const [request, setRequest] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [data, setdata] = useState([]);
    const [fromDate, setFromDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    const [toDate, setToDate] = useState(new Date());

    useEffect(() => {
        fetchReport();
    }, []);

    const fetchReport = async () => {
        try {
            debugger;
            var obj = {
                REP_FROM: fromDate,
                REP_TO: toDate
            }
            const response = await adminInstance.post(`expenserequest/GetReport`, obj);
            setRequest(response.data || []);
            setdata(response.data || []);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
            debugger;
        } finally {
            console.log('Fetch process completed.');
        }
    };

    const exportReport = () => {
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

        // Write Excel File
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });


        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "ReimbursementReport-" + getFormattedDate() + ".xlsx");
    }

    const getFormattedDate = () => {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        return (
            pad(now.getDate()) +
            pad(now.getMonth() + 1) +
            now.getFullYear() +
            pad(now.getHours()) +
            pad(now.getMinutes()) +
            pad(now.getSeconds())
        );
    }

    const navigate = useNavigate();

    const handleView = (reqId) => {
        var urlName = "MyExpenseRequestDetail";
        navigate(`/${urlName}/${reqId}`);
    }

    const filteredData = data
        .filter(spare =>
            spare.EMP_NAME?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            spare.TRAVEL_TYPE?.toLowerCase().includes(searchTerm.toLowerCase())
        );

    return (
        <>

            <>
                <div className="card aon-card">
                    <div className="card-header aon-card-header">
                        <h4>
                            Reimbursement Report
                        </h4>
                    </div>
                    <div className="card-body aon-card-body">
                        {
                            <div className="sf-bs-data-table">
                                <div>

                                <div className="d-flex align-items-end mb-3" style={{ gap: '1rem' }}>
                                    <Form.Group controlId="fromDate">
                                        <Form.Label>From</Form.Label>
                                        <Form.Control
                                                type="date"
                                                value={fromDate}
                                            onChange={e => {
                                                const from = e.target.value;
                                                setFromDate(from);
                                            }}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="toDate">
                                        <Form.Label>To</Form.Label>
                                        <Form.Control
                                                type="date"
                                                value={toDate}
                                            onChange={e => {
                                                const to = e.target.value;
                                                setToDate(to);
                                            }}
                                        />
                                    </Form.Group>
                                    <Button
                                            variant="primary"
                                            onClick={() => fetchReport()}
                                    >
                                        Submit
                                        </Button>
                                        <Button
                                            variant="primary"
                                            onClick={() => exportReport()}
                                        >
                                            Export
                                        </Button>
                                </div>
                                </div>
                                <div className="table-responsive">
                                    {/* Not  */}
                                    <table className="table table-striped table-bordered example-dt-table aon-booking-table responsive" style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>Date</th>
                                                <th>Travel Date</th>
                                                <th>Employee</th>
                                                <th>Travel Type</th>
                                                <th>Amount</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr >
                                                <td colSpan={8}>
                                                    <InputGroup className="mb-3">
                                                        <Form.Control
                                                            placeholder="Search request..."
                                                            value={searchTerm}
                                                            onChange={e => setSearchTerm(e.target.value)}
                                                        />
                                                    </InputGroup>
                                                </td>
                                            </tr>
                                            {
                                                filteredData?.map((emp, index) => {
                                                    return (
                                                        <tr key={uuidv4()}>
                                                            <td>{emp.ID}</td>
                                                            <td>{new Date(emp.REQ_DATE).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            })}</td>
                                                            <td>{new Date(emp.TRAVEL_DATE).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            })}</td>
                                                            <td>{emp.EMP_NAME}</td>
                                                            <td>{emp.TRAVEL_TYPE}</td>
                                                            <td>{emp.TOTAL_AMT}</td>
                                                            <td>{emp.REQ_STATUS}</td>
                                                            <td>
                                                                <button className="admin-button wid-200" onClick={() => handleView(emp.ID)} style={{ marginRight: 20 }}>View</button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </>

        </>
    );
}

export default ExpenseReportPage;
